/** @jsx jsx */
import { jsx } from 'theme-ui';
var normalLogo = require('../../images/logo-dark.png');
var lightLogo = require('../../images/logo-light.png');
var whiteLogo = require('../../images/logo-white.png');
export var ProductLogo = function (_a) {
    var className = _a.className, light = _a.light, monochrome = _a.monochrome;
    return (jsx("img", { sx: { maxHeight: '3rem' }, className: className, src: light ? (monochrome ? whiteLogo : lightLogo) : normalLogo, alt: "Clara" }));
};
//# sourceMappingURL=ProductLogo.js.map